import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import OpportunityStatusEnum from '../Enums/OpportunityStatusEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import LookupText from '../Elements/LookupText';
import JsxHelper from '../Helpers/JsxHelper';
import OtherFeeAdmin from '../Contents/Sales/OtherFee/OtherFeeAdmin';
import CurrencyService from '../Services/CurrencyService';
import dateTimeHelper from '../Helpers/datetimeHelper';
import LookupTextLookupItemIdArray from '../Elements/LookupTextLookupItemIdArray';
import PricingMain from '../Contents/Sales/PricingAdmin/PricingMain';
import urlHelper from '../Helpers/urlHelper';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import LongText from '../Elements/LongText';
import LogComponent from '../Elements/LogComponent';
import ShowNameComponent from '../Elements/ShowNameComponent';
import MoneyFormatFromCurrencyIdComponent from '../Elements/MoneyFormatFromCurrencyIdComponent';
import ErrorMessage from '../Elements/ErrorMessage';

class ServiceListItem {
  constructor(item) {
    if (item === undefined) {
      this.ActionPlansReqd = '';
      this.AddInsured = '';
      this.AddInsuredFee = '';
      this.AddStaffHoursFee = '';
      this.AllowedSameShopperFreq = '';
      this.AllowSelfAssign = '';
      this.ApolloCollaborationUsed = '';
      this.AreaTypes = '';
      this.AvgIvrcallLength = '';
      this.AvgNonRecordedCallLength = '';
      this.AvgVocazillaCallLength = '';
      this.BaseSetUpFee = '';
      this.BasicQualificationReq = '';
      this.CertificationCreationFee = '';
      this.CertOfInsurance = '';
      this.CertOfInsuranceFee = '';
      this.CertTestProvided = '';
      this.ChildAgeRange = '';
      this.ClientContractFee = '';
      this.ClientId = '';
      this.ClientName = '';
      this.ClientDaysToPayCode = '';
      this.ClientInvoiceInterestRate = '';
      this.ClientTrainingProvided = '';
      this.ClientTrainingReqd = '';
      this.ClientSassieId = '';
      this.CollaboratedMspname = '';
      this.CompanyReportReqd = '';
      this.ConsultingFee = '';
      this.ConsultingTravel = '';
      this.ContactId = '';
      this.CreatedBy = '';
      this.CreatedOn = '';
      this.CurrencyCode = '';
      this.CustomReportingFee = '';
      this.DataCaptureMethodCode = '';
      this.DataCaptureTime = '';
      this.DatacheckingFee = '';
      this.DataCheckOfficeId = '';
      this.PricingAuditDataCaptureMethod = '';
      this.DataResearchFee = '';
      this.DetailedReportingRequirements = '';
      this.EditingFee = '';
      this.EditingOfficeId = '';
      this.EditingOfficeOption = 1;
      this.Education = '';
      this.EstShopDuration = '';
      this.EvaluationDuration = '';
      this.EvaluationType = '';
      this.EvaluatorRotation = '';
      this.FieldworkCycleCode = '';
      this.FormCreationFee = '';
      this.GenderCode = '';
      this.GuidelineCreationFee = '';
      this.GuidelinesProvided = '';
      this.HasChildren = '';
      this.HeightMax = '';
      this.HeightMin = '';
      this.HeightUnit = '';
      this.IsChildRequiredForVisit = '';
      this.IsIncluded = true;
      this.LeftRightLocReqd = '';
      this.LocationListOptions = '';
      this.MaritalStatusCode = '';
      this.MaxAge = '';
      this.MaxDeliveryAfterShop = '';
      this.MaxPurchaseAmt = '';
      this.MinAge = '';
      this.MinShopperRating = '';
      this.ModifiedBy = '';
      this.ModifiedOn = '';
      this.MspacertLevel = '';
      this.Name = '';
      this.NonCompleteProcess = '';
      this.NumBillToAddrs = '';
      this.NumCallsNonRecorded = 0;
      this.NumCallsRecorded = '';
      this.NumChildren = '';
      this.NumClosedQuestions = '';
      this.NumCommentBoxes = '';
      this.NumCyclesPerYr = '';
      this.NumEvalsPerCycle = '';
      this.NumGuidlines = '';
      this.NumLanguages = '';
      this.NumNarrativeQuestions = '';
      this.NumOpenQuestions = '';
      this.NumPhotographsReqd = '';
      this.NumScenariosProvided = '';
      this.NumTrainingQuiz = '';
      this.OfficeId = '';
      this.OpportunityId = '';
      this.OpportunityName = '';
      this.OpportunityStatusCode = '';
      this.OtherDataCaptureMethod = '';
      this.OtherEspcriteria = '';
      this.OtherEvaluatorRotation = '';
      this.OtherGenderSplit = '';
      this.OtherPhotosDesc = '';
      this.OtherQualifications = '';
      this.OtherValidationReqd = '';
      this.OwningOfficeIsChecking = '';
      this.OwningOfficeIsEditing = '';
      this.OwningOfficeIsTranslating = '';
      this.PhoneCallDescription = '';
      this.PhotosReqd = '';
      this.PhysicalRequirements = '';
      this.PostCallRequired = '';
      this.PresentationFee = '';
      this.PresentationTravel = '';
      this.PurchaseAmt = '';
      this.PurchaseAmtCurId = '';
      this.PurchaseDesc = '';
      this.PurchaseIncluded = '';
      this.PurchaseReimbursed = '';
      this.PurchaseReqd = '';
      this.PurchaseReturned = '';
      this.QuestionnaireProvided = '';
      this.ReceiptReqd = '';
      this.RegionalReportReqd = '';
      this.ReportFormat = '';
      this.ReportLanguage = '';
      this.ReportLanguageReqdCode = '';
      this.RequiredLanguageCode = '';
      this.ReviewPresFreqCode = '';
      this.ScenarioDesc = '';
      this.ServiceDesc = '';
      this.ServiceId = '';
      this.SoundRecordingReqd = '';
      this.SpeakerQualificationReq = '';
      this.SpecRequestProcess = '';
      this.StateReportReqd = '';
      this.SurveyChangeFreqCode = '';
      this.TimeConstraints = '';
      this.TranslationFee = '';
      this.TranslationProvided = '';
      this.TypeCode = '';
      this.UseClientContract = '';
      this.WeightMax = '';
      this.WeightMin = '';
      this.WeightUnit = '';
      this.OpportunityCurrency = '';
      this.OpportunityCurrencyName = '';
      this.OpportunityAssignedToName = '';
      this.UserCanExportService = false;
      this.CommissionYear = null;
      this.CommissionYearText = 'Not Commissionable';
      this.CommissionRate = '0%';
      this.PrimarySalesRep = '';
      this.OverrideCommissionRate = null;
      this.CommissionExternalSalesPartnerId = null;
      this.CommissionExternalSalesPartnerName = null;
      this.ActionableInsights = '';
      this.AspectBasedSentimentAnalysis = '';
      this.BenchmarkingAgainstIndustry = '';
      this.BiconsultancyDescription = '';
      this.BusinessInformationDescription = '';
      this.CallFlowDescription = '';
      this.ChecklistDetails = '';
      this.ClientGuidelines = '';
      this.CustomExportsRequired = '';
      this.DurationOfSurvey = '';
      this.EmotionAnalytics = '';
      this.FollowUpPeriodExpected = '';
      this.FrequencyOfSurvey = '';
      this.GoalOfProgram = '';
      this.IncentiveCoordinationDescription = '';
      this.IncentivesDescription = '';
      this.InsightHighlights = '';
      this.Kpianalysis = '';
      this.LanguagesToMonitor = '';
      this.NumCompetitors = '';
      this.Objective = '';
      this.OtherDemographicRequirements = '';
      this.OtherTargetAudienceRequirements = '';
      this.PhotosDescription = '';
      this.PreferredTimeline = '';
      this.PriceAccuracySladescription = '';
      this.ProductOrServiceInquiry = '';
      this.ProductType = '';
      this.Regularity = '';
      this.SpecificRequirements = '';
      this.Summarization = '';
      this.TargetAudience = '';
      this.TopicModeling = '';
      this.TopIssues = '';
      this.TypeOfServiceRequested = '';
      this.ApproxNumQuestionsPerSurvey = '';
      this.ComparisonsByRegion = '';
      this.ComparisonsByWave = '';
      this.EstimatedTimePerAudit = '';
      this.Frequency = '';
      this.Keywords = '';
      this.LengthOfSurvey = '';
      this.NumAuditSurveys = '';
      this.NumCallAttemptsPerEval = '';
      this.NumDaysInField = '';
      this.NumEvalPerCycle = '';
      this.NumInterviewersPerLocation = '';
      this.NumItemsPricesPerLocation = '';
      this.NumLocations = '';
      this.NumOpenEndsAnalyzed = '';
      this.NumResponsesRequested = '';
      this.NumScreenshotsRequired = '';
      this.SourcesTypeOfPrograms = '';
      this.SubDashboards = '';
      this.TargetNumResponses = '';
      this.UserAccess = '';
      this.UserRoles = '';
      this.Apirequirement = '';
      this.AuthorizationLetterProvided = '';
      this.CallerIdNeeded = '';
      this.CollaborationInDataSoftware = '';
      this.DescriptionGatheringRequired = '';
      this.IncentiveProvidedByBare = '';
      this.LocationListProvided = '';
      this.LocationsDeliveredByClient = '';
      this.PhoneCallsRequired = '';
      this.PhonePurchaseRequired = '';
      this.ReimbursementRequired = '';
      this.StorefrontPhotoRequired = '';
      this.VideoValidationReqd = '';
      this.VoicemailTimeStampScreenshot = '';
      this.AnnouncedOrUnannounced = '';
      this.AuditSchedule = '';
      this.BareBrandedOrCompanyBranded = '';
      this.BareOrClientSend = '';
      this.BareOrClientSurvey = '';
      this.BitoolSelection = '';
      this.CallingAheadRequired = '';
      this.ComparisonsByWaveAndRegion = '';
      this.CompetitorPricingStudy = '';
      this.Coverage = '';
      this.DataPoints = '';
      this.DataSourcesOtherThanMs = '';
      this.DeliveryPlatform = '';
      this.EmployeesEnterName = '';
      this.FictiosWebsiteCreationNeeded = '';
      this.FrequencyOfMonitoring = '';
      this.FrequencyOfUpdate = '';
      this.GenderB2c = '';
      this.InLocationOrEntrance = '';
      this.InteractionRequired = '';
      this.IsBusinessInformationRequired = '';
      this.LetterOfAuthorizationRequired = '';
      this.LocationListSource = '';
      this.MainMetrics = '';
      this.MonitoringType = '';
      this.Mspplatform = '';
      this.NumVisualizations = '';
      this.BiNumVisualizations = '';
      this.OperationalScope = '';
      this.Output = '';
      this.PriceAccuracySlarequired = '';
      this.SmsorEmailForBare = '';
      this.TabletOrPaper = '';
      this.Template = '';
      this.UpcjanianscanRequired = '';
      this.AdditionalVisualizations = [];
      this.B2borB2c = [];
      this.DirectedPricingApproach = [];
      this.DirectedPricingApproachDetails = '';
      this.DistributionOfSurvey = [];
      this.DistributionOfSurveyDetails = '';
      this.IccoordinatorBilingualRequired = '';
      this.InStoreOrOnline = [];
      this.InteractiveFeatures = [];
      this.KpisBehaviorRequirements = [];
      this.LocationType = '';
      this.PlatformsToMonitor = [];
      this.PricingAspectsToEvaluate = [];
      this.ReportingRequirements = [];
      this.ScopeOfMonitoring = [];
      this.SmsweChatWhatsappScreenshots = [];
      this.SpecialLocations = [];
      this.Tools = [];
      this.TypeOfStores = [];
      this.ViaEmailChatBotOrOther = [];
      this.RequiredLanguageCode = '';
      this.LocationTypeDetails = '';
      // CD-4888 new fields
      this.Reporting = '';
      this.VideoRecordingReqd = '';
      this.PrePostPhoneCall = '';
      this.SurveyReportDeliver = '';
      this.GeoLocationTagging = '';
      this.Comparison = [];
      this.ComparisonDescription = '';
      this.SubDashboardsDescription = '';
      this.TextAnalyticsVerbatimNonEnglish = '';
      this.TextAnalyticsVerbatimDescription = '';
      this.TextAnalyticsOutputsNonEnglish = '';
      this.ServicesNeed = [];
      this.ExportsRequired = '';
      this.ActionItemsPlans = '';
      this.BiMainMetrics = [];
      this.Selected = false;
      return;
    }
    this.ActionPlansReqd = item.actionPlansReqd;
    this.AddInsured = item.addInsured;
    this.AddInsuredFee = item.addInsuredFee;
    this.AddStaffHoursFee = item.addStaffHoursFee;
    this.AllowedSameShopperFreq = item.allowedSameShopperFreq;
    this.AllowSelfAssign = item.allowSelfAssign;
    this.ApolloCollaborationUsed = `${item.apolloCollaborationUsed}`;
    this.AreaTypes = item.areaTypes;
    this.AvgIvrcallLength = item.avgIvrcallLength;
    this.AvgNonRecordedCallLength = item.avgNonRecordedCallLength;
    this.AvgVocazillaCallLength = item.avgVocazillaCallLength;
    this.BaseSetUpFee = item.baseSetUpFee;
    this.BasicQualificationReq = item.basicQualificationReq;
    this.CertificationCreationFee = item.certificationCreationFee;
    this.CertOfInsurance = item.certOfInsurance;
    this.CertOfInsuranceFee = item.certOfInsuranceFee;
    this.CertTestProvided = item.certTestProvided;
    this.ChildAgeRange = item.childAgeRange;
    this.ClientContractFee = item.clientContractFee;
    this.ClientId = item.clientId;
    this.ClientSassieId = item.clientSassieId;
    this.ClientName = item.clientName;
    this.ClientDaysToPayCode = item.clientDaysToPayCode;
    this.ClientInvoiceInterestRate = item.clientInvoiceInterestRate;
    this.ClientTrainingProvided = item.clientTrainingProvided;
    this.ClientTrainingReqd = item.clientTrainingReqd;
    this.CollaboratedMspname = item.collaboratedMspname;
    this.CompanyReportReqd = item.companyReportReqd;
    this.ConsultingFee = item.consultingFee;
    this.ConsultingTravel = item.consultingTravel;
    this.ContactId = item.contactId;
    this.CreatedBy = item.createdBy;
    this.CreatedOn = item.createdOn;
    this.CurrencyCode = '';
    this.CustomReportingFee = item.customReportingFee;
    this.DataCaptureMethodCode = item.dataCaptureMethodCode;
    this.DataCaptureTime = item.dataCaptureTime;
    this.DatacheckingFee = item.datacheckingFee;
    this.DataCheckOfficeId = item.dataCheckOfficeId;
    this.DataResearchFee = item.dataResearchFee;
    this.PricingAuditDataCaptureMethod = item.pricingAuditDataCaptureMethod;
    this.DetailedReportingRequirements = item.detailedReportingRequirements;
    this.EditingFee = item.editingFee;
    this.EditingOfficeId = item.editingOfficeId;
    this.EditingOfficeOption = item.editingOfficeOption;
    this.Education = item.education;
    this.EstShopDuration = item.estShopDuration;
    this.EvaluationDuration = item.evaluationDuration;
    this.EvaluationType = item.evaluationType;
    this.EvaluatorRotation = item.evaluatorRotation;
    this.FieldworkCycleCode = item.fieldworkCycleCode;
    this.FormCreationFee = item.formCreationFee;
    this.GenderCode = item.genderCode;
    this.GuidelineCreationFee = item.guidelineCreationFee;
    this.GuidelinesProvided = item.guidelinesProvided;
    this.HasChildren = item.hasChildren;
    this.HeightMax = item.heightMax;
    this.HeightMin = item.heightMin;
    this.HeightUnit = item.heightUnit;
    this.IsChildRequiredForVisit = `${item.isChildRequiredForVisit}`;
    this.IsIncluded = item.isIncluded;
    this.LeftRightLocReqd = item.leftRightLocReqd;
    this.LocationListOptions = item.locationListOptions;
    this.MaritalStatusCode = item.maritalStatusCode;
    this.MaxAge = item.maxAge;
    this.MaxDeliveryAfterShop = item.maxDeliveryAfterShop;
    this.MaxPurchaseAmt = item.maxPurchaseAmt;
    this.MinAge = item.minAge;
    this.MinShopperRating = item.minShopperRating;
    this.ModifiedBy = item.modifiedBy;
    this.ModifiedOn = item.modifiedOn;
    this.MspacertLevel = item.mspacertLevel;
    this.Name = item.name;
    this.NonCompleteProcess = item.nonCompleteProcess;
    this.NumBillToAddrs = item.numBillToAddrs;
    this.NumCallsNonRecorded = item.numCallsNonRecorded;
    this.NumCallsRecorded = item.numCallsRecorded;
    this.NumChildren = item.numChildren;
    this.NumClosedQuestions = item.numClosedQuestions;
    this.NumCommentBoxes = item.numCommentBoxes;
    this.NumCyclesPerYr = item.numCyclesPerYr;
    this.NumEvalsPerCycle = item.numEvalsPerCycle;
    this.NumGuidlines = item.numGuidlines;
    this.NumLanguages = item.numLanguages;
    this.NumNarrativeQuestions = item.numNarrativeQuestions;
    this.NumOpenQuestions = item.numOpenQuestions;
    this.NumPhotographsReqd = item.numPhotographsReqd;
    this.NumScenariosProvided = item.numScenariosProvided;
    this.NumTrainingQuiz = item.numTrainingQuiz;
    this.OfficeId = item.officeId;
    this.OpportunityId = item.opportunityId;
    this.OpportunityName = item.opportunityName;
    this.OpportunityStatusCode = item.opportunityStatusCode;
    this.OtherDataCaptureMethod = item.otherDataCaptureMethod;
    this.OtherEspcriteria = item.otherEspcriteria;
    this.OtherEvaluatorRotation = item.otherEvaluatorRotation;
    this.OtherGenderSplit = item.otherGenderSplit;
    this.OtherPhotosDesc = item.otherPhotosDesc;
    this.OtherQualifications = item.otherQualifications;
    this.OtherValidationReqd = item.otherValidationReqd;
    this.OwningOfficeIsChecking = item.owningOfficeIsChecking;
    this.OwningOfficeIsEditing = item.owningOfficeIsEditing;
    this.OwningOfficeIsTranslating = item.owningOfficeIsTranslating;
    this.PhoneCallDescription = item.phoneCallDescription;
    this.PhotosReqd = item.photosReqd;
    this.PhysicalRequirements = item.physicalRequirements;
    this.PostCallRequired = item.postCallRequired;
    this.PresentationFee = item.presentationFee;
    this.PresentationTravel = item.presentationTravel;
    this.PurchaseAmt = item.purchaseAmt;
    this.PurchaseAmtCurId = item.purchaseAmtCurId;
    this.PurchaseDesc = item.purchaseDesc;
    this.PurchaseIncluded = item.purchaseIncluded;
    this.PurchaseReimbursed = item.purchaseReimbursed;
    this.PurchaseReqd = item.purchaseReqd;
    this.PurchaseReturned = item.purchaseReturned;
    this.QuestionnaireProvided = item.questionnaireProvided;
    this.ReceiptReqd = item.receiptReqd;
    this.RegionalReportReqd = item.regionalReportReqd;
    this.ReportFormat = item.reportFormat;
    this.ReportLanguage = item.reportLanguage;
    this.ReportLanguageReqdCode = item.reportLanguageReqdCode;
    this.ReviewPresFreqCode = item.reviewPresFreqCode;
    this.ScenarioDesc = item.scenarioDesc;
    this.ServiceDesc = item.serviceDesc;
    this.ServiceId = item.serviceId;
    this.SoundRecordingReqd = item.soundRecordingReqd;
    this.SpeakerQualificationReq = item.speakerQualificationReq;
    this.SpecRequestProcess = item.specRequestProcess;
    this.StateReportReqd = item.stateReportReqd;
    this.SurveyChangeFreqCode = item.surveyChangeFreqCode;
    this.TimeConstraints = item.timeConstraints;
    this.TranslationFee = item.translationFee;
    this.TranslationProvided = item.translationProvided;
    this.TypeCode = item.typeCode;
    this.UseClientContract = item.useClientContract;
    this.WeightMax = item.weightMax;
    this.WeightMin = item.weightMin;
    this.WeightUnit = item.weightUnit;
    this.OpportunityCurrency = item.opportunityCurrency;
    this.OpportunityCurrencyName = item.opportunityCurrencyName;
    this.OpportunityAssignedToName = item.opportunityAssignedToName;
    this.UserCanExportService = item.userCanExportService;
    this.CommissionYear = item.commissionYear;
    this.CommissionYearText = !item.commissionYear ? 'Not Commissionable' : `Year ${item.commissionYear}`;
    this.CommissionRate = !(item.overrideCommissionRate ?? item.commissionRate)
      ? '0%'
      : `${item.overrideCommissionRate ?? item.commissionRate}%`;
    this.PrimarySalesRep = item.primarySalesRep;
    this.OverrideCommissionRate = item.overrideCommissionRate;
    this.CommissionExternalSalesPartnerId = item.commissionExternalSalesPartnerId;
    this.CommissionExternalSalesPartnerName = item.commissionExternalSalesPartnerName;
    this.ActionableInsights = item.actionableInsights;
    this.AspectBasedSentimentAnalysis = item.aspectBasedSentimentAnalysis;
    this.BenchmarkingAgainstIndustry = item.benchmarkingAgainstIndustry;
    this.BiconsultancyDescription = item.biconsultancyDescription;
    this.BusinessInformationDescription = item.businessInformationDescription;
    this.CallFlowDescription = item.callFlowDescription;
    this.ChecklistDetails = item.checklistDetails;
    this.ClientGuidelines = item.clientGuidelines;
    this.CustomExportsRequired = item.customExportsRequired;
    this.DurationOfSurvey = item.durationOfSurvey;
    this.EmotionAnalytics = item.emotionAnalytics;
    this.FollowUpPeriodExpected = item.followUpPeriodExpected;
    this.FrequencyOfSurvey = item.frequencyOfSurvey;
    this.GoalOfProgram = item.goalOfProgram;
    this.IncentiveCoordinationDescription = item.incentiveCoordinationDescription;
    this.IncentivesDescription = item.incentivesDescription;
    this.InsightHighlights = item.insightHighlights;
    this.Kpianalysis = item.kpianalysis;
    this.LanguagesToMonitor = item.languagesToMonitor;
    this.NumCompetitors = item.numCompetitors;
    this.Objective = item.objective;
    this.OtherDemographicRequirements = item.otherDemographicRequirements;
    this.OtherTargetAudienceRequirements = item.otherTargetAudienceRequirements;
    this.PhotosDescription = item.photosDescription;
    this.PreferredTimeline = item.preferredTimeline;
    this.PriceAccuracySladescription = item.priceAccuracySladescription;
    this.ProductOrServiceInquiry = item.productOrServiceInquiry;
    this.ProductType = item.productType;
    this.Regularity = item.regularity;
    this.SpecificRequirements = item.specificRequirements;
    this.Summarization = item.summarization;
    this.TargetAudience = item.targetAudience;
    this.TopicModeling = item.topicModeling;
    this.TopIssues = item.topIssues;
    this.TypeOfServiceRequested = item.typeOfServiceRequested;
    this.ApproxNumQuestionsPerSurvey = item.approxNumQuestionsPerSurvey;
    this.ComparisonsByRegion = item.comparisonsByRegion;
    this.ComparisonsByWave = item.comparisonsByWave;
    this.EstimatedTimePerAudit = item.estimatedTimePerAudit;
    this.Frequency = item.frequency;
    this.Keywords = item.keywords;
    this.LengthOfSurvey = item.lengthOfSurvey;
    this.NumAuditSurveys = item.numAuditSurveys;
    this.NumCallAttemptsPerEval = item.numCallAttemptsPerEval;
    this.NumDaysInField = item.numDaysInField;
    this.NumEvalPerCycle = item.numEvalPerCycle;
    this.NumInterviewersPerLocation = item.numInterviewersPerLocation;
    this.NumItemsPricesPerLocation = item.numItemsPricesPerLocation;
    this.NumLocations = item.numLocations;
    this.NumOpenEndsAnalyzed = item.numOpenEndsAnalyzed;
    this.NumResponsesRequested = item.numResponsesRequested;
    this.NumScreenshotsRequired = item.numScreenshotsRequired;
    this.SourcesTypeOfPrograms = item.sourcesTypeOfPrograms;
    this.SubDashboards = item.subDashboards;
    this.TargetNumResponses = item.targetNumResponses;
    this.UserAccess = item.userAccess;
    this.UserRoles = item.userRoles;
    this.Apirequirement = item.apirequirement;
    this.AuthorizationLetterProvided = item.authorizationLetterProvided;
    this.CallerIdNeeded = item.callerIdNeeded;
    this.CollaborationInDataSoftware = item.collaborationInDataSoftware;
    this.DescriptionGatheringRequired = item.descriptionGatheringRequired;
    this.IncentiveProvidedByBare = item.incentiveProvidedByBare;
    this.LocationListProvided = item.locationListProvided;
    this.LocationsDeliveredByClient = item.locationsDeliveredByClient;
    this.PhoneCallsRequired = item.phoneCallsRequired;
    this.PhonePurchaseRequired = item.phonePurchaseRequired;
    this.ReimbursementRequired = item.reimbursementRequired;
    this.StorefrontPhotoRequired = item.storefrontPhotoRequired;
    this.VideoValidationReqd = item.videoValidationReqd;
    this.VoicemailTimeStampScreenshot = item.voicemailTimeStampScreenshot;
    this.AnnouncedOrUnannounced = item.announcedOrUnannounced;
    this.AuditSchedule = item.auditSchedule;
    this.BareBrandedOrCompanyBranded = item.bareBrandedOrCompanyBranded;
    this.BareOrClientSend = item.bareOrClientSend;
    this.BareOrClientSurvey = item.bareOrClientSurvey;
    this.BitoolSelection = item.bitoolSelection;
    this.CallingAheadRequired = item.callingAheadRequired;
    this.ComparisonsByWaveAndRegion = item.comparisonsByWaveAndRegion;
    this.CompetitorPricingStudy = item.competitorPricingStudy;
    this.Coverage = item.coverage;
    this.DataPoints = item.dataPoints;
    this.DataSourcesOtherThanMs = item.dataSourcesOtherThanMs;
    this.DeliveryPlatform = item.deliveryPlatform;
    this.EmployeesEnterName = item.employeesEnterName;
    this.FictiosWebsiteCreationNeeded = item.fictiosWebsiteCreationNeeded;
    this.FrequencyOfMonitoring = item.frequencyOfMonitoring;
    this.FrequencyOfUpdate = item.frequencyOfUpdate;
    this.GenderB2c = item.genderB2c;
    this.InLocationOrEntrance = item.inLocationOrEntrance;
    this.InteractionRequired = item.interactionRequired;
    this.IsBusinessInformationRequired = item.isBusinessInformationRequired;
    this.LetterOfAuthorizationRequired = item.letterOfAuthorizationRequired;
    this.LocationListSource = item.locationListSource;
    this.MainMetrics = item.mainMetrics;
    this.MonitoringType = item.monitoringType;
    this.Mspplatform = item.mspplatform;
    this.NumVisualizations = item.numVisualizations;
    this.BiNumVisualizations = item.biNumVisualizations;
    this.OperationalScope = item.operationalScope;
    this.Output = item.output;
    this.PriceAccuracySlarequired = item.priceAccuracySlarequired;
    this.SmsorEmailForBare = item.smsorEmailForBare;
    this.TabletOrPaper = item.tabletOrPaper;
    this.Template = item.template;
    this.UpcjanianscanRequired = item.upcjanianscanRequired;
    this.AdditionalVisualizations = item.additionalVisualizations;
    this.B2borB2c = item.b2borB2c;
    this.DirectedPricingApproach = item.directedPricingApproach;
    this.DirectedPricingApproachDetails = item.directedPricingApproachDetails;
    this.DistributionOfSurvey = item.distributionOfSurvey;
    this.DistributionOfSurveyDetails = item.distributionOfSurveyDetails;
    this.IccoordinatorBilingualRequired = item.iccoordinatorBilingualRequired;
    this.InStoreOrOnline = item.inStoreOrOnline;
    this.InteractiveFeatures = item.interactiveFeatures;
    this.KpisBehaviorRequirements = item.kpisBehaviorRequirements;
    this.LocationType = item.locationType;
    this.PlatformsToMonitor = item.platformsToMonitor;
    this.PricingAspectsToEvaluate = item.pricingAspectsToEvaluate;
    this.ReportingRequirements = item.reportingRequirements;
    this.ScopeOfMonitoring = item.scopeOfMonitoring;
    this.SmsweChatWhatsappScreenshots = item.smsweChatWhatsappScreenshots;
    this.SpecialLocations = item.specialLocations;
    this.Tools = item.tools;
    this.TypeOfStores = item.typeOfStores;
    this.ViaEmailChatBotOrOther = item.viaEmailChatBotOrOther;
    this.RequiredLanguageCode = item.requiredLanguageCode;
    this.LocationTypeDetails = item.locationTypeDetails;
    // CD-4888 new fields
    this.Reporting = item.reporting;
    this.VideoRecordingReqd = item.videoRecordingReqd;
    this.PrePostPhoneCall = item.prePostPhoneCall;
    this.SurveyReportDeliver = item.surveyReportDeliver;
    this.GeoLocationTagging = item.geoLocationTagging;
    this.Comparison = item.comparison;
    this.ComparisonDescription = item.comparisonDescription;
    this.SubDashboardsDescription = item.subDashboardsDescription;
    this.TextAnalyticsVerbatimNonEnglish = item.textAnalyticsVerbatimNonEnglish;
    this.TextAnalyticsVerbatimDescription = item.textAnalyticsVerbatimDescription;
    this.TextAnalyticsOutputsNonEnglish = item.textAnalyticsOutputsNonEnglish;
    this.ServicesNeed = item.servicesNeed;
    this.ExportsRequired = item.exportsRequired;
    this.ActionItemsPlans = item.actionItemsPlans;
    this.BiMainMetrics = item.biMainMetrics;
    this.Selected = false;

    if (item.requiredLanguageCode !== null) {
      this.RequiredLanguageCode = item.requiredLanguageCode.split(',').map((item) => parseInt(item, 10));
    }
  }

  static NameOfTheIdField() {
    return 'ServiceId';
  }
  static nameOfTheItemDetailList = (item) => (
    <LongText
      text={`Service - ${item.Name} #${item.ServiceId} (Opp.: ${item.OpportunityName})`}
      fitToBox
    />
  );

  static MoneyFields = [];

  static Currency() {
    return 'USD';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return 'USD';
  }

  static DateFields = ['ModifiedOn'];
  static NavigationDesc = ['ClientName', 'OpportunityName'];

  static BoolFields = [];
  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        { name: (item) => `${item.Name} (${item.ServiceId})`, label: 'Name' },
        { name: 'OpportunityName', label: 'Opportunity' },
        {
          name: (item) => (
            <LookupText
              lookupId={15}
              value={item.TypeCode}
            />
          ),
          label: 'Type Name',
        },
        { name: (item) => JsxHelper.YesNo(item.IsIncluded), label: 'Is Included?' },
        {
          name: (item) => (
            <LookupText
              lookupId={19}
              value={item.OpportunityStatusCode}
            />
          ),
          label: 'Opportunity Status',
        },
        { name: 'OpportunityAssignedToName', label: 'Opportunity Assigned To' },
        { name: 'CommissionYearText', label: 'Commission Year' },
        { name: 'CommissionRate', label: 'Commission Rate' },
        { name: 'PrimarySalesRep', label: 'Primary Sales Rep' },
        { name: 'CommissionExternalSalesPartnerName', label: 'External Sales Partner' },

        { name: 'ServiceDesc', label: 'Description of Service/Scenario', width: TabListTableCellWidthEnum.TwoLines },

        { name: '-', label: 'Frequency' },
        {
          name: (item) => (
            <LookupText
              lookupId={16}
              value={item.FieldworkCycleCode}
            />
          ),
          label: 'Fieldwork Cycle',
        },
        { name: 'NumCyclesPerYr', label: 'No. Cycles Per Year' },
        { name: 'NumEvalsPerCycle', label: 'No. Evals Per Cycle' },

        { name: '-', label: 'Fieldwork Requirements' },
        { name: 'TimeConstraints', label: 'Visit Time Constraints (days/hours/etc)' },
        {
          name: (item) => (
            <LookupText
              lookupId={36}
              value={item.EvaluatorRotation}
            />
          ),
          label: 'Evaluator Rotation',
        },
        {
          name: (item) => (
            <LookupText
              lookupId={37}
              value={item.MaxDeliveryAfterShop}
            />
          ),
          label: 'Time to Deliver Evaluation to Client',
        },

        {
          name: (item) => (
            <LookupText
              lookupId={105}
              value={item.LocationListOptions}
            />
          ),
          label: 'Location List',
        },
        {
          name: (item) => (
            <LookupText
              lookupId={106}
              value={item.AreaTypes}
            />
          ),
          label: 'Area type',
        },

        { name: '-', label: 'Fieldwork Requirements' },
        {
          name: 'DetailedReportingRequirements',
          label: 'Detailed Reporting Requirements',
          width: TabListTableCellWidthEnum.TwoLines,
        },
        { name: 'Reporting', label: 'Reporting' },
      ],
    },
    {
      tabName: 'Evaluation',
      tabLabel: 'Evaluation',
      icon: 'fa-solid fa-user-secret',
      data: [
        { name: '-', label: 'Evaluation Duration' },
        {
          name: (item) => dateTimeHelper.convertMinutesToDate(item.EvaluationDuration * 60),
          label: 'Evaluation Duration',
        },

        { name: '-', label: 'Phone Call Requirements' },

        { name: 'NumCallsRecorded', label: 'No. Recorded Calls per Evaluation' },
        { name: 'AvgVocazillaCallLength', label: 'Avg. Recorded Call Length (min) per Call' },
        { name: 'NumCallsNonRecorded', label: 'No. of Non-Recorded Calls per Evaluation' },
        { name: 'AvgNonRecordedCallLength', label: 'Avg. Non-Recorded Call Length (min) per Call' },
        { name: 'PhoneCallDescription', label: 'Description of Calls', width: TabListTableCellWidthEnum.TwoLines },

        { name: '-', label: 'Visit Validation' },
        { name: 'NumPhotographsReqd', label: 'Number of Photographs Required' },
        { name: (item) => JsxHelper.YesNo(item.ReceiptReqd), label: 'Receipt Required?' },
        { name: (item) => JsxHelper.YesNo(item.PhotosReqd), label: 'Storefront Photo Required?' },
        { name: (item) => JsxHelper.YesNo(item.SoundRecordingReqd), label: 'Sound Recording Required?' },
        {
          name: (item) => JsxHelper.YesNo(item.LeftRightLocReqd),
          label: 'Left and Right of Storefront Photos Required?',
        },
        {
          name: (item) => (
            <LookupText
              lookupId={35}
              value={item.OtherValidationReqd}
            />
          ),
          label: 'Other Validation',
        },
        {
          name: 'OtherPhotosDesc',
          label: 'Describe other Photographs Required',
          width: TabListTableCellWidthEnum.TwoLines,
        },

        { name: '-', label: 'Purchase' },
        {
          name: (item) => (
            <ShowNameComponent
              serviceFunction={CurrencyService.GetCurrencyNameById}
              id={item.PurchaseAmtCurId}
            />
          ),
          label: 'Purchase Amount Currency',
        },
        { name: (item) => JsxHelper.YesNo(item.PurchaseReqd), label: 'Purchase Required?' },
        { name: (item) => JsxHelper.YesNo(item.PurchaseReimbursed), label: 'Purchase Reimbursed by Client?' },
        {
          name: (item) => (
            <MoneyFormatFromCurrencyIdComponent
              moneySum={item.PurchaseAmt}
              currencyId={item.PurchaseAmtCurId}
            />
          ),
          label: 'Minimum Purchase Amount',
        },
        { name: '', label: '' },

        { name: (item) => JsxHelper.YesNo(item.PurchaseIncluded), label: 'Purchase NOT Reimbursed by BARE or Client?' },
        {
          name: (item) => (
            <MoneyFormatFromCurrencyIdComponent
              moneySum={item.MaxPurchaseAmt}
              currencyId={item.PurchaseAmtCurId}
            />
          ),
          label: `Maximum Purchase Amount`,
        },
        { name: '', label: '' },

        {
          name: (item) => JsxHelper.YesNo(item.PurchaseReturned),
          label: 'Required Purchase to be returned by Evaluator as part of their Assignment Scenario?',
        },
        { name: 'PurchaseDesc', width: TabListTableCellWidthEnum.TwoLines, label: 'Item Required to Be Purchased' },
      ],
    },
    {
      tabName: 'Questionnaire',
      tabLabel: 'Questionnaire',
      icon: 'fa-solid fa-clipboard-question',
      data: [
        {
          name: (item) => (
            <LookupText
              lookupId={107}
              value={item.ReportLanguage}
            />
          ),
          label: 'Report Language',
        },
        { name: (item) => JsxHelper.YesNo(item.QuestionnaireProvided), label: 'Questionnaire Provided by Client?' },
        {
          name: (item) => (
            <LookupTextLookupItemIdArray
              lookupId={20}
              valueArray={item.RequiredLanguageCode}
            />
          ),
          label: 'Required Language(s)',
        },

        { name: 'NumClosedQuestions', label: 'No. Closed Questions' },
        { name: (item) => JsxHelper.YesNo(item.ClientTrainingProvided), label: 'Client Training Provided?' },
        {
          name: (item) => (
            <LookupText
              lookupId={16}
              value={item.SurveyChangeFreqCode}
            />
          ),
          label: 'Survey Change Cycle',
        },

        { name: 'NumOpenQuestions', label: 'No. Simple Text Questions' },
        {
          name: (item) => JsxHelper.YesNo(item.TranslationProvided),
          label: 'Translation of Questionnaire Provided by Client?',
        },
        {
          name: (item) => (
            <LookupText
              lookupId={21}
              value={item.DataCaptureMethodCode}
            />
          ),
          label: 'Data Capture Method',
        },

        { name: 'NumNarrativeQuestions', label: 'No. Narrative Questions' },
        { name: (item) => JsxHelper.YesNo(item.CertTestProvided), label: 'Certification Test Provided by Client?' },
        {
          name: (item) => JsxHelper.YesNo(item.ApolloCollaborationUsed),
          label: 'Will Collaboration be used in Apollo?',
        },

        { name: 'OtherDataCaptureMethod', label: 'Other Data Capture Method Description' },
        { name: (item) => JsxHelper.YesNo(item.GuidelinesProvided), label: 'Guidelines Provided by Client?' },
        { name: 'CollaboratedMspname', label: 'Name of MSP for which this will be Collaborated' },
      ],
    },
    {
      tabName: 'Demographics',
      tabLabel: 'Demographics',
      icon: 'fa-solid fa-graduation-cap',
      data: [
        { name: '-', label: 'Demographics' },
        { name: 'MinAge', label: 'Minimum Age' },
        {
          name: (item) => (
            <LookupText
              lookupId={18}
              value={item.MaritalStatusCode}
            />
          ),
          label: 'Martial Status',
        },
        {
          name: (item) => (
            <LookupText
              lookupId={17}
              value={item.GenderCode}
            />
          ),
          label: 'Gender',
        },
        { name: 'MaxAge', label: 'Maximum Age' },
        { name: (item) => JsxHelper.YesNo(item.IsChildRequiredForVisit), label: 'Child Required for Visit' },
        { name: 'OtherGenderSplit', label: 'Other Gender Split' },
        {
          name: (item) => (
            <LookupText
              lookupId={34}
              value={item.Education}
            />
          ),
          label: 'Minimum Education Level',
        },
        { name: 'ChildAgeRange', label: 'Child Age Range' },
        {
          name: (item) => (
            <LookupText
              lookupId={61}
              value={item.EvaluationType}
            />
          ),
          label: 'Who can do Evaluations',
        },
        { name: 'PhysicalRequirements', label: 'Physical Requirements', width: TabListTableCellWidthEnum.TwoLines },
        { name: '-', label: 'Other Demographics' },
        { name: 'OtherQualifications', label: 'Other Qualifications' },
      ],
    },
    {
      tabName: 'Other Fees',
      tabLabel: 'Other Fees',
      icon: 'fa-solid fa-scale-balanced',
      data: [{ name: ServiceListItem.GetOtherService, label: 'Other Fees', width: TabListTableCellWidthEnum.Table }],
    },
    {
      tabName: 'Pricing',
      tabLabel: 'Pricing',
      icon: 'fa-solid fa-money-check-dollar-pen',
      rolekey: 'PricingDataTable',
      data: [{ name: ServiceListItem.getPricing, label: 'Pricing', width: TabListTableCellWidthEnum.Table }],
    },
    {
      tabName: 'Log',
      tabLabel: 'Log',
      icon: 'fa-solid fa-stream',
      data: [{ name: ServiceListItem.getLogContent, label: 'Log', width: TabListTableCellWidthEnum.Table }],
    },
  ];

  static generalTab = [ServiceListItem.FieldsToShowInListTable[0]];
  static commonEndTabs = ServiceListItem.FieldsToShowInListTable.slice(-3);

  static getSelectedCellHeader(item) {
    return (
      <div>
        <input
          type='checkbox'
          checked={ServiceListItem.selectedStatus()}
          onChange={(e) => {
            ServiceListItem.clickOnGlobalSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static getSelectedCellContent(item) {
    return (
      <input
        type='checkbox'
        checked={item.Selected}
        onChange={(e) => {
          ServiceListItem.clickOnSelect(item, e.target.checked);
        }}
      />
    );
  }
  static FieldsToShowInDataTable() {
    return [
      {
        label: ServiceListItem.getSelectedCellHeader,
        orderById: '',
        data: ServiceListItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      { label: 'Service Id', orderById: 'ServiceId', data: 'ServiceId', type: FieldTypesEnum.DataFieldWithDetails },
      {
        label: 'Service Id',
        orderById: 'ServiceId',
        data: ServiceListItem.GetDetailCellContent,
        type: FieldTypesEnum.Navigation,
      },
      { label: 'Service', orderById: 'Name', data: (item) => <LongText text={item.Name} /> },
      { label: 'Opportunity', orderById: 'OpportunityName', data: (item) => <LongText text={item.OpportunityName} /> },
      { label: 'Client', orderById: 'ClientName', data: (item) => <LongText text={item.ClientName} /> },
      {
        label: 'Type',
        orderById: 'Type',
        data: (item) => (
          <LookupText
            lookupId={15}
            value={item.TypeCode}
          />
        ),
      },
      { label: 'Modified On', orderById: 'ModifiedOn', data: 'ModifiedOn' },
      { label: 'Included?', orderById: 'IsIncluded', data: (item) => JsxHelper.YesNo(item.IsIncluded) },
      { label: ' ', orderById: '', data: ServiceListItem.getActionsContent, type: FieldTypesEnum.ActionButton },
    ];
  }

  static getLogContent(item) {
    return (
      <LogComponent
        entityType='Service'
        entityId={item.ServiceId}
      />
    );
  }

  static GetDetailCellContent(item) {
    if (ServiceListItem.OnFullPage()) return item.ServiceId;
    return urlHelper.getIconLinkComponentFigma(
      item.ServiceId,
      'fa-solid fa-arrow-up-right-from-square',
      'text-primary pl-1 pr-1',
      'servicedetails',
      `id=${item.ServiceId}`,
      'Open up in a new tab'
    );
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            roleKey: 'opportunity_edit',
            disabled:
              item.OpportunityStatusCode === OpportunityStatusEnum.OpportunityWon ||
              item.OpportunityStatusCode === OpportunityStatusEnum.OpportunityLost,
            onClick: () => ServiceListItem.editGeneralFunction(item.ServiceId, item),
          },
          {
            iconName: 'fa-solid fa-copy',
            text: 'Copy Service',
            roleKey: 'opportunity_edit',
            disabled:
              item.OpportunityStatusCode === OpportunityStatusEnum.OpportunityWon ||
              item.OpportunityStatusCode === OpportunityStatusEnum.OpportunityLost,
            onClick: () => ServiceListItem.CopyGeneralFunction(item.ServiceId, item),
          },
          {
            iconName: item.IsIncluded === true ? 'fa-solid fa-lock ' : 'fa-solid fa-lock-open ',
            roleKey: 'opportunity_edit',
            text: item.IsIncluded === true ? 'Exclude Service' : 'Include Service',
            disabled:
              item.OpportunityStatusCode === OpportunityStatusEnum.OpportunityWon ||
              item.OpportunityStatusCode === OpportunityStatusEnum.OpportunityLost,
            onClick: () => ServiceListItem.StatusChangeGeneralFunction(item.ServiceId, item),
          },
          {
            iconName: 'fa-regular fa-trash-can ',
            text: 'Remove',
            roleKey: 'opportunity_edit',
            disabled:
              item.OpportunityStatusCode === OpportunityStatusEnum.OpportunityWon ||
              item.OpportunityStatusCode === OpportunityStatusEnum.OpportunityLost,
            onClick: () => ServiceListItem.RemoveGeneralFunction(item.ServiceId, item),
          },
        ]}
      />
    );
  }

  static editGeneralFunction = (id, user, userList) => {
    alert('Empty function');
  };

  static editGeneralFunction = (id, user, userList) => {
    alert('Empty function');
  };

  static CopyGeneralFunction = (id, user, userList) => {
    alert('Empty function');
  };

  static StatusChangeGeneralFunction = (id, user, userList) => {
    alert('Empty function');
  };

  static RemoveGeneralFunction = (id, user, userList) => {
    alert('Empty function');
  };

  static clickOnGlobalSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static clickOnSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static selectedStatus() {
    return false;
  }

  GetCurrencyCode(item) {
    if (item.PurchaseAmtCurId === null) return '';
    CurrencyService.GetGlobalDataCurrencies(item.PurchaseAmtCurId)
      .then((result) => (item.CurrencyCode = result.code))
      .catch(() => ErrorMessage.SetErrorMessage('SLI557'));
    return item.CurrencyCode;
  }

  static GetOtherService(item) {
    return (
      <OtherFeeAdmin
        ActionsDisabled={item.OpportunityStatusCode !== OpportunityStatusEnum.OpportunityWon}
        Service={item}
      />
    );
  }

  static getPricing(item) {
    return (
      <PricingMain
        ServiceId={item.ServiceId}
        OpportunityStatusCode={item.OpportunityStatusCode}
      />
    );
  }
}

export default ServiceListItem;
